import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getVoucherTypes, clearVoucherTypes } from '../../../../actions/index';
import { DEFAULT_SELECT_PLACEHOLDER } from '../../../../config/constants';
import { DEFAULT_QUERY_GET_ALL } from '../../../../config/queries';
import Select from '../../../common/forms/select/Select';
import { optionsPropTypes } from '../../../common/forms/select/SelectPropTypes';

const VoucherTypeMigrationSelect = ({
  loading,
  options,
  isGridVariant,
  value,
  isMulti,
  isClearable,
  onValueChange,
  placeholder,
  dispatchGetVoucherTypes,
  dispatchClearVoucherTypes,
  ...rest
}) => {
  useEffect(() => {
    dispatchGetVoucherTypes(DEFAULT_QUERY_GET_ALL);

    return () => {
      dispatchClearVoucherTypes();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Select
      isLoading={loading}
      options={options}
      isMulti={isMulti}
      input={{ value }}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      placeholder={placeholder}
      {...rest}
    />
  );
};

VoucherTypeMigrationSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  options: optionsPropTypes.isRequired,
  loading: PropTypes.bool.isRequired,
  noOptionsMessage: PropTypes.func,
  dispatchGetVoucherTypes: PropTypes.func.isRequired,
  dispatchClearVoucherTypes: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  onValueChange: PropTypes.func,
  isMulti: PropTypes.bool,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  }),
  displayInPaymentPage: PropTypes.bool,
};

VoucherTypeMigrationSelect.defaultProps = {
  noOptionsMessage: undefined,
  isDisabled: false,
  isGridVariant: false,
  onValueChange: undefined,
  isClearable: true,
  value: {},
  isMulti: false,
  placeholder: DEFAULT_SELECT_PLACEHOLDER,
  displayInPaymentPage: false,
};

const mapStateToProps = ({ AccountingUnit }, { displayInPaymentPage }) => {
  const allVoucherTypes = AccountingUnit.VoucherType.getIn([
    'all',
    'content',
    'content',
  ]).map((voucherType) => ({
    value: voucherType.id,
    label: `${voucherType.voucherCode} - ${voucherType.name}`,
    voucherCode: voucherType.voucherCode,
    displayInPaymentsPage: voucherType.displayInPaymentsPage,
  }));
  return {
    options: displayInPaymentPage
      ? allVoucherTypes.filter(
          (voucherType) => voucherType.displayInPaymentsPage,
        )
      : allVoucherTypes,
    loading: AccountingUnit.VoucherType.getIn(['all', 'loading']),
  };
};

const mapDispatchToProps = {
  dispatchGetVoucherTypes: getVoucherTypes,
  dispatchClearVoucherTypes: clearVoucherTypes,
};

export default connect(mapStateToProps, mapDispatchToProps)(VoucherTypeMigrationSelect);
